/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS, doT) {
	'use strict';
	/*globals Tc */

	/**
	 *
	 * Subscribes to channels: ['EcommerceProductDataHub']
	 * Listens to channel events: ['EcommerceProductDataHub']
	 * Triggers channel events: ['subscribeForProductData']
	 *
	 * @namespace Tc.Module
	 * @class EcommerceProductDetail
	 * @extends Tc.Module
	 */
	Tc.Module.EcommerceProductDetail = Tc.Module.extend({

		Type: {
			description: 'description',
			features: 'features',
			contracts: 'contracts',
			deliveryScope: 'deliveryscope',
			ecoPoints: 'ecopoints',
			topFeatures: 'topfeatures',
			promotionName: 'promotionName',
			redflagText: 'redflagText',
			sameDayDelivery: 'sameDayDelivery'
		},

		// used to convert dialog style placeholders to dotJs placeholders
		PLACEHOLDERS: [
			[/\$\{sddMinimumPurchaseAmount\}/g, '{{=it.sddMinimumPurchaseAmount}}'],
			[/\$\{sddShippingFee\}/g, '{{=it.sddShippingFee}}']
		],

		on: function (callback) {
			var mod = this;
			mod.type = mod.$ctx.data('type');
			mod.templateHtml = mod.replacePlaceholders(mod.$ctx.find('script.tmpl').detach().html() || '');
			mod.template = doT.template(mod.templateHtml);
			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.dataChanged);
			callback();
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		dataChanged: function(info) {
			var mod = this;
			switch (mod.type) {
				case mod.Type.topFeatures:
					if (info.product) {
						mod.createTopFeatures(info.product);
					}
					break;
				case mod.Type.description:
					if (info.product) {
						mod.createDescriptions(info.product);
					}
					break;
				case mod.Type.promotionName:
					if (info.product) {
						mod.createPromotionName(info);
					}
					break;
				case mod.Type.redflagText:
					if (info.product) {
						mod.createRedFlagText(info.product);
					}
					break;
				case mod.Type.sameDayDelivery:
					if (info.product) {
						mod.createSameDayDelivery(info.product);
					}
					break;
				default:
					if (info.product) {
						mod.requestDetailsCallback(info.product.getDetails());
					}
					break;
			}
		},

		populateTemplate: function (data) {
			var mod = this;
			if (data) {
				mod.$ctx.html(mod.template(data));
				mod.$ctx.removeClass('hidden');
				SCS.utils.initNewModules(mod.$ctx);
			} else {
				mod.$ctx.html('');
				mod.$ctx.addClass('hidden');
			}
		},

		requestDetails: function () {
			var mod = this;
			if (mod.productDataChannel) {
				mod.fire('getDetails', {
					callback: $.proxy(mod.requestDetailsCallback, mod)
				}, [mod.productDataChannel]);
			}
		},

		requestDetailsCallback: function (details) {
			var mod = this;
			if (details) {
				switch (mod.type) {
					case mod.Type.features:
						mod.createFeatures(details);
						break;
					case mod.Type.contracts:
						mod.createContracts(details);
						break;
					case mod.Type.deliveryScope:
						mod.createDeliveryScope(details);
						break;
					case mod.Type.ecoPoints:
						mod.createEcoPoints(details);
						break;
				}
			} else {
				mod.populateTemplate();
			}
		},

		createFeatures: function (details) {
			var mod = this;
			var features = mod.cleanupFeatures(details.getFeatures());
			mod.populateTemplate(features);
		},

		createDescriptions: function (product) {
			var mod = this;
			var features = mod.cleanupFeatures(product.getFeatures());

			if (typeof features === 'string') {
				features = features.replace(/<ul>/g, '<ul class="list">')
			}

			mod.populateTemplate(features);
		},

		createPromotionName: function (info) {
			var promos = info.product.getApplicablePromotions(
				info.subscriptionId,
				info.subscriptionDuration,
				info.subscriptionType
			).filter(function(promo) {
				return !promo.isCallout();
			});

			this.populateTemplate(promos);
		},

		createRedFlagText: function (product) {
			var mod = this,
				data = null;

			if (product.getRedFlagText() && product.getRedFlagText().length) {
				data = {text: product.getRedFlagText()};
			}
			mod.populateTemplate(data);
		},

		createSameDayDelivery: function (product) {
			var mod = this,
				data = null;
			if(product.isSddAllowed()) {
				data = {};
				data.sddMinimumPurchaseAmount = product.getSddMinimumPurchaseAmount();
				data.sddShippingFee = product.getSddShippingFee();
			}

			mod.populateTemplate(data);
		},

		createContracts: function (details) {
			var mod = this, i,
				conditions = details.getGeneralTermsAndConditions(),
				data = {
					items: []
				};
			data.guaranteePeriod = details.getGuaranteePeriod();
			for (i = 0; i < conditions.length; i+=1) {
				data.items.push({
					title: conditions[i].Title,
					url: conditions[i].Url
				});
			}
			mod.populateTemplate(data);
		},

		createDeliveryScope: function (details) {
			var mod = this;
			mod.populateTemplate(details.getDeliveryFeatures());
		},

		createEcoPoints: function (details) {
			var mod = this, data;
			if (details.getEcoPoints() > 0 && details.getPowerConsumption() > 0 && details.getProductionEnergy() > 0 && details.getRawMaterialSelection() > 0) {
				data = {
					ecoPoints: details.getEcoPoints(),
					powerConsumption: details.getPowerConsumption(),
					productionEnergy: details.getProductionEnergy(),
					rawMaterialSelection: details.getRawMaterialSelection()
				};
			}
			mod.populateTemplate(data);
		},

		createTopFeatures: function (product) {
			var mod = this, i,
				features = product.getTopFeatures(),
				data = {
					items: []
				};
			data.slogan = product.getSlogan();
			for (i = 0; i < features.length; i+=1) {
				data.items.push(features[i]);
			}
			mod.populateTemplate(data);
		},

		replacePlaceholders: function (templateHtml) {
			for( var i = 0, length = this.PLACEHOLDERS.length; i < length; i+=1) {
				templateHtml = templateHtml.replace(this.PLACEHOLDERS[i][0], this.PLACEHOLDERS[i][1]);
			}

			return templateHtml;
		},

		cleanupFeatures: function(features) {
			if (!features || !features.filter) {
				return features;
			}
			var found = {};
			return features.filter(function(feature) {
				if (feature.feature && feature.getName() && !found[feature.getName()] && !feature.isBlacklisted() ) {
					found[feature.getName()] = true;

					return true;
				}
			});
		}
	});

})(Tc.$, window.SCS, window.doT);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.EcommerceProductDetail.js
// module id = 249
// module chunks = 0